import React, {useContext} from "react";
import { Box } from "@mui/material";
import styles from './ChatContent.module.sass';
import ChatHeader from "../ChatHeader";
import ChatFooter from "../ChatFooter";
import ChatMessages from "../ChatMessages";

const ChatContent = ({ onBackCallback }) => {

    return <Box className={styles.main_container}>
        <ChatHeader onBackCallback={onBackCallback}/>
        <ChatMessages/>
        <ChatFooter/>
    </Box>

};

export default ChatContent;